import React from 'react';

const SingleInstrumentDetailRightMenu = () => {
  return <></>;
};

export default SingleInstrumentDetailRightMenu;
